import { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';

import type { IFormTariff, IParameters } from '../../models';
import { filterParameters } from '../../helpers/credit-filters';
import { calculateTariffPayment } from '../../helpers/calculate-tariff-payment';
import { activeTariffActualization } from '../../helpers/active-tariff-actualization';

/** Обработчик логики калькулятора */
export const Trade = () => {
    const {
        values: { activeTariff, amount, clientType, depositStatus, tariffs, term },
    } = useFormState<IFormTariff>({
        subscription: { values: true },
    });
    const { change } = useForm();

    useEffect(() => {
        const parameters: IParameters = {
            amount,
            term,
            goal: [depositStatus, clientType],
        };
        const filtredParams = filterParameters(tariffs, parameters);

        // При синхронном выполнении форма не успевала подменить значения filteredTariffs  и карточки не отрисовывались
        requestAnimationFrame(() => {
            change('filteredTariffs', filtredParams);

            // Актуализация состояния активного тарифа от изменений оборота или массива тарифов
            activeTariffActualization({ activeTariff, change, filteredTariffs: filtredParams });
        });

        change(
            'payment',
            calculateTariffPayment({
                countingType: activeTariff.countingType,
                parameters,
                percentValue: activeTariff.percentValue,
            })
        );

        change('formStatus', 'fulfilled');

        // Пересчет выгодных условий при изменении активного тарифа
        requestAnimationFrame(() => {
            change(
                'payment',
                calculateTariffPayment({
                    countingType: activeTariff.countingType,
                    parameters: {
                        amount,
                        term,
                        goal: [depositStatus, clientType],
                    },
                    percentValue: activeTariff.percentValue,
                })
            );
        });
    }, [tariffs, amount, term, depositStatus, clientType, activeTariff, change]);

    return null;
};
